import React from "react";
// import ShopkeeperDetailCard from "../components/ShopkeeperDetailCard";
import ShopkeeperRegistration from "../components/ShopkeeperRegistration";

function DetailPage() {
  return (
    <div>
      {/* <ShopkeeperDetailCard /> */}
      <ShopkeeperRegistration/>
    </div>
  );
}

export default DetailPage;
